/**
 * Session gate for the activate “fill basket” follow-up strip.
 * Set when the primary Place an order CTA (`open_orders`) is clicked.
 */

const KEY_PREFIX = 'oms_ge_fill_basket_followup_'

function storageKey(venueId) {
  return `${KEY_PREFIX}${venueId}`
}

export function markGrowthEngineFillBasketFollowUp(venueId) {
  if (!venueId || typeof sessionStorage === 'undefined') return
  try {
    sessionStorage.setItem(storageKey(venueId), '1')
  } catch {
    // Private mode / quota — follow-up stays empty-basket-only without session.
  }
}

export function hasGrowthEngineFillBasketFollowUp(venueId) {
  if (!venueId || typeof sessionStorage === 'undefined') return false
  try {
    return sessionStorage.getItem(storageKey(venueId)) === '1'
  } catch {
    return false
  }
}

export function clearGrowthEngineFillBasketFollowUp(venueId) {
  if (!venueId || typeof sessionStorage === 'undefined') return
  try {
    sessionStorage.removeItem(storageKey(venueId))
  } catch {
    // ignore
  }
}

/** Test helper */
export function __resetGrowthEngineFillBasketFollowUpForTests() {
  if (typeof sessionStorage === 'undefined') return
  try {
    const keys = []
    for (let i = 0; i < sessionStorage.length; i += 1) {
      const key = sessionStorage.key(i)
      if (key && key.startsWith(KEY_PREFIX)) keys.push(key)
    }
    keys.forEach(key => sessionStorage.removeItem(key))
  } catch {
    // ignore
  }
}
